/**
 * @generated SignedSource<<dde10476334f7ee7ff6e275934498b84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type confluenceTemplateDetailsContentfulRelayPageQuery$variables = {
  locale?: string | null | undefined;
  urlSlug?: string | null | undefined;
};
export type confluenceTemplateDetailsContentfulRelayPageQuery$data = {
  readonly templates: {
    readonly items: ReadonlyArray<{
      readonly pluginModuleKey: string | null | undefined;
      readonly sys: {
        readonly id: string;
      };
      readonly templateNameExternal: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"templateCategorySectionContentfulRelayFragment" | "templateDetailsSectionContentfulRelayFragment" | "templateHeaderSectionContentfulRelayFragment" | "templateKeyFeaturesSectionContentfulRelayFragment">;
    } | null | undefined>;
  } | null | undefined;
};
export type confluenceTemplateDetailsContentfulRelayPageQuery = {
  response: confluenceTemplateDetailsContentfulRelayPageQuery$data;
  variables: confluenceTemplateDetailsContentfulRelayPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "urlSlug"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "urlSlug",
        "variableName": "urlSlug"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateNameExternal",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pluginModuleKey",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organizationNameExternal",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "CompanyNameInternal",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "CompanyNameInternal",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductTemplateTemplateTypeCollection",
  "kind": "LinkedField",
  "name": "templateTypeCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyTemplateType",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateTypeNameExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
    "selections": [
      {
        "alias": "templates",
        "args": (v1/*: any*/),
        "concreteType": "ProductTemplateCollection",
        "kind": "LinkedField",
        "name": "productTemplateCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplate",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "templateHeaderSectionContentfulRelayFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "templateKeyFeaturesSectionContentfulRelayFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "templateCategorySectionContentfulRelayFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "templateDetailsSectionContentfulRelayFragment"
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
    "selections": [
      {
        "alias": "templates",
        "args": (v1/*: any*/),
        "concreteType": "ProductTemplateCollection",
        "kind": "LinkedField",
        "name": "productTemplateCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplate",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oneLinerHeadline",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contributor",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "authorNameExternal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobTitle",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "type": "Author",
                    "abstractKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateKeyFeaturesCollection",
                "kind": "LinkedField",
                "name": "keyFeaturesCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyFeature",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "featureNameExternal",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": "categories",
                "args": null,
                "concreteType": "ProductTemplateCategoryCollection",
                "kind": "LinkedField",
                "name": "categoryCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyTemplateCategory",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "categoryNameExternal",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "templatePreviews",
                "args": null,
                "concreteType": "AssetCollection",
                "kind": "LinkedField",
                "name": "templatePreviewCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateAboutThisTemplate",
                "kind": "LinkedField",
                "name": "aboutThisTemplate",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateOverviewCollection",
                "kind": "LinkedField",
                "name": "templateOverviewCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateOverview",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "overviewTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateOverviewOverviewDescription",
                        "kind": "LinkedField",
                        "name": "overviewDescription",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateBenefitsCollection",
                "kind": "LinkedField",
                "name": "templateBenefitsCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateBenefitContainer",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "benefitsTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateBenefitContainerTemplateBenefitContainerCollection",
                        "kind": "LinkedField",
                        "name": "templateBenefitContainerCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateBenefit",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "templateBenefitNameExternal",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateBenefitShortDescription",
                                "kind": "LinkedField",
                                "name": "shortDescription",
                                "plural": false,
                                "selections": (v12/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateHowToUseThisTemplateCollection",
                "kind": "LinkedField",
                "name": "howToUseThisTemplateCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateGuide",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templateGuideNameExternal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateGuideTemplateStepsCollection",
                        "kind": "LinkedField",
                        "name": "templateStepsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateUseStep",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "stepNameExternal",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateUseStepStepDescription",
                                "kind": "LinkedField",
                                "name": "stepDescription",
                                "plural": false,
                                "selections": (v12/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Asset",
                                "kind": "LinkedField",
                                "name": "stepAsset",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateProductRationaleCollection",
                "kind": "LinkedField",
                "name": "templateProductRationaleCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateProductRationale",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rationaleTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateProductRationaleTemplateProductRationaleDescription",
                        "kind": "LinkedField",
                        "name": "templateProductRationaleDescription",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateRelatedTemplatesCollection",
                "kind": "LinkedField",
                "name": "relatedTemplatesCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductTemplate",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previewBlurb",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "contributor",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/)
                            ],
                            "type": "Author",
                            "abstractKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b596ee2882ea9db74e15e337575a8c4d",
    "id": null,
    "metadata": {},
    "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
    "operationKind": "query",
    "text": "query confluenceTemplateDetailsContentfulRelayPageQuery(\n  $locale: String\n  $urlSlug: String\n) {\n  templates: productTemplateCollection(limit: 1, locale: $locale, where: {urlSlug: $urlSlug}) {\n    items {\n      sys {\n        id\n      }\n      ...templateHeaderSectionContentfulRelayFragment\n      ...templateKeyFeaturesSectionContentfulRelayFragment\n      ...templateCategorySectionContentfulRelayFragment\n      ...templateDetailsSectionContentfulRelayFragment\n      templateNameExternal\n      pluginModuleKey\n    }\n  }\n}\n\nfragment templateAuthorContentfulRelayFragment on ProductTemplate {\n  contributor {\n    __typename\n    ... on Author {\n      authorNameExternal\n      jobTitle\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templateBenefitsContentfulRelayFragment on TemplateBenefitContainer {\n  benefitsTitle\n  templateBenefitContainerCollection {\n    items {\n      templateBenefitNameExternal\n      shortDescription {\n        json\n      }\n    }\n  }\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templateCategorySectionContentfulRelayFragment on ProductTemplate {\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  categories: categoryCollection {\n    items {\n      sys {\n        id\n      }\n      categoryNameExternal\n      urlSlug\n    }\n  }\n}\n\nfragment templateDescriptionContentfulRelayFragment on ProductTemplate {\n  aboutThisTemplate {\n    json\n  }\n}\n\nfragment templateDetailsSectionContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  pluginModuleKey\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  ...templatePreviewContentfulRelayFragment\n  ...templateDescriptionContentfulRelayFragment\n  ...templateTabbedSectionContentfulRelayFragment\n  ...templateRelatedTemplatesContentfulRelayFragment\n}\n\nfragment templateGuideContentfulRelayFragment on TemplateGuide {\n  templateGuideNameExternal\n  templateStepsCollection {\n    items {\n      stepNameExternal\n      stepDescription {\n        json\n      }\n      stepAsset {\n        url\n      }\n    }\n  }\n}\n\nfragment templateHeaderSectionContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  oneLinerHeadline\n  pluginModuleKey\n  ...templateAuthorContentfulRelayFragment\n}\n\nfragment templateKeyFeaturesSectionContentfulRelayFragment on ProductTemplate {\n  keyFeaturesCollection {\n    items {\n      featureNameExternal\n    }\n  }\n}\n\nfragment templatePreviewContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n    }\n  }\n  templatePreviews: templatePreviewCollection {\n    items {\n      url\n    }\n  }\n}\n\nfragment templateRelatedTemplatesContentfulRelayFragment on ProductTemplate {\n  relatedTemplatesCollection {\n    items {\n      sys {\n        id\n      }\n      ...templateCardContentfulRelayFragment\n    }\n  }\n}\n\nfragment templateTabbedSectionContentfulRelayFragment on ProductTemplate {\n  templateOverviewCollection {\n    items {\n      overviewTitle\n      overviewDescription {\n        json\n      }\n    }\n  }\n  templateBenefitsCollection {\n    items {\n      ...templateBenefitsContentfulRelayFragment\n    }\n  }\n  howToUseThisTemplateCollection {\n    items {\n      ...templateGuideContentfulRelayFragment\n    }\n  }\n  templateProductRationaleCollection {\n    items {\n      rationaleTitle\n      templateProductRationaleDescription {\n        json\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0128fa2c07bae89c6da6e76df6cb863";

export default node;
